export default {
  oidc: {
    issuer: `https://truevalue.okta.com`,
    clientId: "0oa1sw7w3n3ajIH940h8", //dev
    // clientId: "0oa1up97tho45XmSe0h8", //Prod
    scopes: ["openid", "profile", "email"],
    redirectUri: `${window.location.origin}/login/callback`,
  },
  widget: {
    issuer: "https://truevalue.okta.com",
    clientId: "0oa1sw7w3n3ajIH940h8", //dev
    // clientId: "0oa1up97tho45XmSe0h8", //Prod
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ["openid", "profile", "email"],
  },
};
